<template>
    <div v-if="this.type == 'widget'" class="air--route">
      <Dropdown  ref="flightSelRef" :options="flights" :selected="flightId" :placeholder="`Select Flight`" :updater="changeFlight" />


      <!-- <select v-model="flightId">
        <option v-for="flight in flights" :value="flight.value" :key="flight.value">{{ flight.text }}</option>
      </select> -->
    </div>

    <div v-else class="air--route-frame">
      <FlightsDropdown ref="flightSelRef" :options="flights" :selected="flightId" :placeholder="`Select Flight`" :updater="changeFlight" />
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Dropdown from '../Lib/Dropdown'
import FlightsDropdown from '../Lib/FlightsDropdown'

export default {
  props: ['type'],
  beforeUpdate () {
    // console.log('[Benchmark]' + this.$options._componentTag + ' beforeUpdate ')
    // this.start = Date.now()
  },

  updated () {
    // let now = Date.now()
    // let passed = (now - this.start) / 1000
    //
    // console.log('[Benchmark]' + this.$options._componentTag + ' updated in ' + passed + 's')

    this.setLoading(false)
  },
  components: {
    Dropdown,
    FlightsDropdown
  },
  methods: {
    ...mapActions(['changeFlight', 'setLoading'])
  },
  computed: {
    flightId () {
      return this.$store.state.flightId
    },
    ...mapState(['data']),
    ...mapGetters(['flight', 'flights'])
  },
  watch: {
    flightId (newFlightId, oldFlightId) {
      this.$refs.flightSelRef.updateSelectedOption(newFlightId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header/FlightSelector.vue